
import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { PokerGameTypes } from "../../constants/PokerGameTypes";
import { SFConstants } from "../../constants/SFConstants";
import { Poker2SitnGoDataEvent } from "../../event/Poker2SitnGoDataEvent";
import { Poker2TournamentDataEvent } from "../../event/Poker2TournamentDataEvent";
import { LobbyTablesVO } from "../../gamevo/LobbyTablesVO";
import { SeatVO } from "../../gamevo/SeatVO";
import { SitnGoVO } from "../../gamevo/SitnGoVO";
import { TournamentResultVO } from "../../gamevo/TournamentResultVO";
import { Poker2StandardOkDialog } from "../../view/dialogs/Poker2StandardOkDialog";
import { Poker2JoinSitnGoDialog } from "../../view/dialogs/sitngo/Poker2JoinSitnGoDialog";
import { Poker2JoinSitnGoDialogProperties } from "../../view/dialogs/sitngo/Poker2JoinSitnGoDialogProperties";
import { Poker2LayoutManager } from "../../view/Poker2LayoutManager";
import { Poker2Model } from "../Poker2Model";
import { BasicData } from "./BasicData";

export class Poker2SitnGoData extends BasicData {
    public sitnGoList: LobbyTablesVO[];
    public currentSitnGoTable: LobbyTablesVO;

    constructor() {

        super();
        this.currentSitnGoTable = new LobbyTablesVO();// init an empty vo incase SJN or SSP comes too late
    }

    /**
     *  S2C_SITNGO_LIST
     **/
    public parse_SLI(paramObject: any): void {
        if (!paramObject)
            return;
        this.parseSitnGoList(paramObject.L);
    }

    /**
     *  S2C_SITNGO_REGISTER
     **/
    public parse_SRE(paramObject: any): void {
        if (!paramObject)
            return;
        this.joinTable(paramObject.id);
        /*			Poker2LayoutManager.getInstance().showDialog( "Poker2JoinSitnGoDialog", new Poker2JoinSitnGoDialogProperties( Poker2Model.languageData.getTextById( "dialog_tournament_register_titel", [ paramObject.name ]), Poker2Model.languageData.getTextById( "dialog_tournament_register_copy", [ paramObject.name ]),paramObject.id, joinTable));
                    controller.dispatchEvent( new Poker2SitnGoDataEvent( "registerSitnGo", [ paramObject.id, paramObject.name ]));*/

    }

    /**
     *  S2C_SITNGO_UNREGISTER
     **/
    public parse_SUR(paramObject: any): void {
        if (!paramObject)
            return;
        //TODO Texte anpassen
        Poker2LayoutManager.getInstance().showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("dialog_tournament_unregister_titel", [paramObject.name]), Poker2Model.languageData.getTextById("dialog_tournament_unregister_copy", [paramObject.name])));
        this.controller.dispatchEvent(new Poker2SitnGoDataEvent("unRegisterSitnGo", [paramObject.id, paramObject.name]));
    }

    /**
     *  S2C_SITNGO_SETBLIND
     **/
    public parse_SSB(paramObject: any): void {
        if (!paramObject)
            return;

        // store small blind for usage in Poker2TableActionPanel, needed for slider stepper
        if (this.currentSitnGoTable) {
            this.currentSitnGoTable.sBlind = int(paramObject.b);
        }

        this.controller.dispatchEvent(new Poker2TournamentDataEvent("tournamentSetBlind", [paramObject.b]));
    }

    /**
     *  S2C_SITNGO_JOIN
     * Als Teilnehmer, type 4
     **/
    public parse_SJN(paramObject: any): void {
        if (!paramObject)
            return;
        //			_selectedTournament = paramObject.jid;
        //controller.dispatchEvent(new Poker2OnTableEvent(Poker2OnTableEvent.SIT_DOWN_AT_TOURNAMENT_TABLE));
        this.currentSitnGoTable = new LobbyTablesVO();
        Poker2Model.onTableData.buildLobbyTableVOsAndSeatVOs(paramObject, PokerGameTypes.SITNGO_TYPE_STANDARD);
    }

    /**
     *  S2C_SITNGO_END
     **/
    // TODO dispatchEvent eventuell auf SitnGo event umschreiben
    public parse_SEN(paramObject: any): TournamentResultVO {
        if (!paramObject)
            return null;
        var tournamentResultVO: TournamentResultVO = new TournamentResultVO();
        tournamentResultVO.name = paramObject.name;
        tournamentResultVO.rank = int(paramObject.rank);
        tournamentResultVO.chips = paramObject.chips ? paramObject.chips : 0;
        tournamentResultVO.gold = paramObject.gold ? paramObject.gold : 0;
        tournamentResultVO.tournamentPoints = int(paramObject.tp ? paramObject.tp : 0);
        tournamentResultVO.gameType = PokerGameTypes.SITNGO_TYPE_STANDARD;

        // texts
        switch (tournamentResultVO.rank) {
            case 1:

                tournamentResultVO.txtTitle = Poker2Model.languageData.getTextById("dialog_tournament_victory_titel");
                tournamentResultVO.txtCopy = Poker2Model.languageData.getTextById("dialog_tournament_victory_copy");
                break;

            case 2:

                tournamentResultVO.txtTitle = Poker2Model.languageData.getTextById("dialog_sitngo_looser_title");
                tournamentResultVO.txtCopy = Poker2Model.languageData.getTextById("dialog_sitngo_2ndPlace_copy", [tournamentResultVO.name]);
                break;

            case 3:

                tournamentResultVO.txtTitle = Poker2Model.languageData.getTextById("dialog_sitngo_looser_title");
                tournamentResultVO.txtCopy = Poker2Model.languageData.getTextById("dialog_sitngo_3rdPlace_copy", [tournamentResultVO.name]);
                break;

            default:

                tournamentResultVO.txtTitle = Poker2Model.languageData.getTextById("dialog_sitngo_looser_title");
                tournamentResultVO.txtCopy = Poker2Model.languageData.getTextById("dialog_sitngo_looser_copy", [tournamentResultVO.name]);
                break;
        }

        if (Poker2Model.onTableData.currentTable) {
            Poker2Model.onTableData.currentTable.tournamentInProgress = false;
        }
        this.controller.dispatchEvent(new Poker2TournamentDataEvent("tournamentEnd", []));
        return tournamentResultVO;
    }

    /**
     *  S2C_SITNGO_INVITATION
     **/
    //TODO Implementieren
    public parse_SIN(paramObject: any): void {
        if (!paramObject)
            return;
        Poker2LayoutManager.getInstance().showDialog("Poker2JoinSitnGoDialog", new Poker2JoinSitnGoDialogProperties(Poker2Model.languageData.getTextById("dialog_sitngo_startMsg_title", [paramObject.name]), Poker2Model.languageData.getTextById("dialog_sitngo_startMsg_copy", [paramObject.name]), paramObject.id, this.bindFunction(this.joinTable)));
        /*			currentTournamentTable = new LobbyTablesVO();
                    currentTournamentTable.id = paramObject.tid;
                    currentTournamentTable.name = paramObject.name;
        
                    // TODO Server muß mir hier die actionTime schicken, dann kann das else weg
                    if (paramObject.actiontime)
                        currentTournamentTable.actionTime = paramObject.actiontime;
                    else
                        currentTournamentTable.actionTime = 20;
                    Poker2LayoutManager.getInstance().showDialog( "Poker2TourInvitationDialog", new Poker2TourInvitationDialogProperties( paramObject.id, paramObject.runtime, paramObject.name, paramObject.round ));*/
    }

    /**
     *  S2C_SITNGO_SPECTATE
     * Als Zuschauer, type 2
     **/
    public parse_SSP(paramObject: any): void {
        if (!paramObject)
            return;
        this.currentSitnGoTable = new LobbyTablesVO();
        Poker2Model.onTableData.buildLobbyTableVOsAndSeatVOs(paramObject, PokerGameTypes.SITNGO_TYPE_STANDARD_SPECTATOR);

    }

    private joinTable(sitnGoId: number): void {
        var paramObject: any = { id: sitnGoId };
        BasicModel.smartfoxClient.sendMessage("sjn", [JSON.stringify(paramObject)]);
    }

    public parse_SZO(paramObject: any): void {
        if (!paramObject)
            return;
        var seatVO: SeatVO = Poker2Model.onTableData.getSeatVOByIndex(paramObject.index);
        seatVO.zombie = int(paramObject.z);
        this.controller.dispatchEvent(new Poker2TournamentDataEvent("changeZombie", [paramObject.z, paramObject.index]));
    }

    private parseSitnGoList(paramArray: any[]): void {
        this.sitnGoList = [];

        if (paramArray)
            if (paramArray != null) {
                for (let entryList of paramArray) {
                    var tableLine: any = entryList;
                    if (tableLine === undefined) continue;

                    var lobbyTablesVO: LobbyTablesVO = new LobbyTablesVO();
                    lobbyTablesVO.sitnGoVO = new SitnGoVO();
                    lobbyTablesVO.sitnGoVO.id = tableLine.shift();
                    lobbyTablesVO.sitnGoVO.name = tableLine.shift();
                    lobbyTablesVO.sitnGoVO.buyIn = tableLine.shift();
                    lobbyTablesVO.sitnGoVO.fee = tableLine.shift();
                    lobbyTablesVO.sitnGoVO.status = tableLine.shift();
                    lobbyTablesVO.sitnGoVO.currentPlayers = tableLine.shift();
                    lobbyTablesVO.sitnGoVO.pot = tableLine.shift();
                    lobbyTablesVO.sitnGoVO.xpEarnStatus = tableLine.shift();
                    this.sitnGoList.push(lobbyTablesVO);
                }
            }
        this.controller.dispatchEvent(new Poker2SitnGoDataEvent("changeSitnGoData"));
    }
}
